import { type DataObjectsManager, type IDataObject } from '@inpart-io/devtools-iap';
import {
    AssetTypes,
    DataType,
    privateAssetProperties,
    privateAssetsManager,
    privateCompaniesManager,
    privateCompanyProperties,
    privateConsumerHealthAssetProperties,
    privateConsumerHealthAssetsManager,
    privateTechnologiesManager,
    privateTechnologyProperties
} from '@inpart-io/padme-iap';

import LeadAssetEditionForm from '@/pages/lead-overview/components/asset-classification/components/lead-asset/lead-asset-edition-form.vue';
import LeadCompanyAssetEditionForm from '@/pages/lead-overview/components/asset-classification/components/lead-company-asset/lead-company-asset-edition-form.vue';
import LeadConsumerHealthAssetEditionForm from '@/pages/lead-overview/components/asset-classification/components/lead-consumer-health-asset/lead-consumer-health-asset-edition-form.vue';
import LeadTechnologyAssetEditionForm from '@/pages/lead-overview/components/asset-classification/components/lead-technology-asset/lead-technology-asset-edition-form.vue';
import { LEAD_ASSET_PROFILE_MODULE } from '@/store/lead-asset-profile-module';
import { LEAD_COMPANY_PROFILE_MODULE } from '@/store/lead-company-profile-module';
import { LEAD_CONSUMER_HEALTH_PROFILE_MODULE } from '@/store/lead-consumer-health-profile-module';
import { LEAD_TECHNOLOGY_PROFILE_MODULE } from '@/store/lead-technology-profile-module';
import { PRIVATE_ASSET_MODULE } from '@/store/private-asset-module';
import { PRIVATE_COMPANY_MODULE } from '@/store/private-company-module';
import { PRIVATE_CONSUMER_HEALTH_ASSET_MODULE } from '@/store/private-consumer-health-asset-module';
import { PRIVATE_TECHNOLOGY_MODULE } from '@/store/private-technology-module';

export interface IAssetTypeObject {
    assetTypeId: string;
    assetProfileType: string;
    assetProfileEntityModule: string;
    assetModule: string;
    assetProperties: string;
    assetManager: DataObjectsManager<IDataObject>;
    assetProfileComponent: string;
    assetProfileEditionForm: any;
}

export interface IAssetTypeOption {
    label: string;
    value: AssetTypes;
    icon: string;
    description?: string;
}

export const assetTypeList = [
    {
        assetTypeId: AssetTypes.PHARMA_ASSET,
        assetProfileType: DataType.LeadAssetProfile,
        assetProfileEntityModule: LEAD_ASSET_PROFILE_MODULE,
        assetModule: PRIVATE_ASSET_MODULE,
        assetProperties: privateAssetProperties.DEFAULT,
        assetManager: privateAssetsManager,
        assetProfileComponent: 'lead-asset',
        assetProfileEditionForm: LeadAssetEditionForm
    },
    {
        assetTypeId: AssetTypes.TECHNO_SOLUTION,
        assetProfileType: DataType.LeadTechnologyProfile,
        assetProfileEntityModule: LEAD_TECHNOLOGY_PROFILE_MODULE,
        assetModule: PRIVATE_TECHNOLOGY_MODULE,
        assetProperties: privateTechnologyProperties.DEFAULT,
        assetManager: privateTechnologiesManager,
        assetProfileComponent: 'lead-technology-asset',
        assetProfileEditionForm: LeadTechnologyAssetEditionForm
    },
    {
        assetTypeId: AssetTypes.CONSUMER_HEALTH,
        assetProfileType: DataType.LeadConsumerHealthProfile,
        assetProfileEntityModule: LEAD_CONSUMER_HEALTH_PROFILE_MODULE,
        assetModule: PRIVATE_CONSUMER_HEALTH_ASSET_MODULE,
        assetProperties: privateConsumerHealthAssetProperties.DEFAULT,
        assetManager: privateConsumerHealthAssetsManager,
        assetProfileComponent: 'lead-consumer-health-asset',
        assetProfileEditionForm: LeadConsumerHealthAssetEditionForm
    },
    {
        assetTypeId: AssetTypes.COMPANY,
        assetProfileType: DataType.LeadCompanyProfile,
        assetProfileEntityModule: LEAD_COMPANY_PROFILE_MODULE,
        assetModule: PRIVATE_COMPANY_MODULE,
        assetProperties: privateCompanyProperties.DEFAULT,
        assetManager: privateCompaniesManager,
        assetProfileComponent: 'lead-company-asset',
        assetProfileEditionForm: LeadCompanyAssetEditionForm
    }
] as IAssetTypeObject[];
